export default "__VITE_ASSET__D24CA1ZF__"